import { baseUrl } from '../../network'

export const createPurchaseOrderUrl = (relationshipId: number) => baseUrl + `api/relationship/${relationshipId}/orders`
